import { FormattedMessage } from 'react-intl';

import type { ImportStatus } from '../../AppAndSiteMarketplace.types';

type Props = {
  status: ImportStatus;
};

const bold = (chunks: React.ReactNode) => <strong className="inventoryList__bannerBold">{chunks}</strong>;

/** Non-dismissible info banner shown while a CSV import is processing or waiting for the user to confirm it. */
export function InventoryImportBanner({ status }: Readonly<Props>) {
  if (status === 'idle') {
    return null;
  }

  const isProcessing = status === 'processing';

  return (
    <div aria-live="polite" className="inventoryList__banner" role="status">
      <i
        aria-hidden="true"
        className={`inventoryList__bannerIcon ${isProcessing ? 'fa-solid fa-spinner fa-spin' : 'fa-regular fa-circle-info'}`}
      />
      <span>
        {isProcessing ? (
          <FormattedMessage
            defaultMessage="<bold>Almost there!</bold> This may take a few moments, we'll let you know as soon as it's done. In the meantime, feel free to continue with the other settings."
            id="appAndSiteMarketplace.inventory.importBanner.processing"
            values={{ bold }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="<bold>Almost there!</bold> Confirm the upload by clicking the edit button on the item on the left."
            id="appAndSiteMarketplace.inventory.importBanner.pendingConfirmation"
            values={{ bold }}
          />
        )}
      </span>
    </div>
  );
}
